export class Contacts {
    "contact_uuid": string = "";
    "contact_types": string = "";
    "contact_organization": string = "";
    "contact_name_given": string = "";
    "contact_name_family": string = "";
    "phone_number": string = "";
    "address_street": string = "";
    "address_extended": string = "";
    "address_community": string | null = null;
    "address_locality": string = "";
    "address_region": string = "";
    "address_postal_code": string = "";
    "address_country": string = "";

}